import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalDeleteComponent} from './modal-delete.component';
import {ModalModule} from 'ngx-bootstrap/modal';
import {BtnCloseModule} from '../../btn-close/btn-close.module';
import {ReactiveFormsModule} from '@angular/forms';
import {NgxPopperModule} from 'ngx-popper';
import {ValidateModule} from '../../../modules/validate/validate.module';


@NgModule({
  declarations: [
    ModalDeleteComponent
  ],
  exports: [
    ModalDeleteComponent
  ],
  imports: [
    CommonModule,
    ModalModule,
    ValidateModule,
    BtnCloseModule,
    NgxPopperModule,
    ReactiveFormsModule,
  ]
})
export class ModalDeleteModule {
}
